import React from 'react'
import { PreLoader } from 'elements'

export default () => (
  <PreLoader />
)



// WEBPACK FOOTER //
// ./src/components/loading/index.js